import {FilterableMailBoxUrlSlugs, MailBoxSlugs, MailBoxUrlSlugs, PrivateMailBoxUrlSlugs} from "@twigsby/client-data";
import {GenericFilterEntryType} from "@twigsby/client-data/lib/Types/GenericTypes";
import {Location} from "react-router-dom";
import {MailScanned, MailType, UnreadType} from "../Types/MailFilterDataTypes";
import {BuildUrlFilterFromParams} from "./UrlSlugsAndFilters";

export interface MailboxUrlParamsType {
    folderId?: string;
    startDate?: string;
    endDate?: string;
    mailType?: string;
    scanned?: string;
    mailTagIds?: string;
    clientFolderIds?: string;
    includeFolderAssigned?: string;
    incomingRecipientNameIds?: string;
    term?: string;
    unreadStatus?: string;
    mailId?: string;
    folderSlug?: string;
}

type BuildMailboxUrlFilterFromParamsType = {
    // @ts-ignore
    [name: keyof MailBoxUrlSlugs]: GenericFilterEntryType;
};

const MapFolderSlugToId = (props: MailboxUrlParamsType) => {
    return props.clientFolderIds || props.mailTagIds || props.unreadStatus ? 8 : MailBoxSlugs[props.folderSlug as string];
}

const MailboxUrlMapping = (props: MailboxUrlParamsType, location: Location): PrivateMailBoxUrlSlugs => {
    let newParams: PrivateMailBoxUrlSlugs = {
        folderId: MapFolderSlugToId(props),
    };

    if(props.clientFolderIds || location.state?.clientFolderIds !== undefined) {
        newParams = {...newParams, ...BuildMailboxUrlFilterFromParams(props, location,'clientFolderIds', null, true) }
    } else {
        newParams = {...newParams, ...BuildMailboxUrlFilterFromParams(props, location,'includeFolderAssigned', null, false, newParams.folderId === 8) }
    }

    return newParams;
}

const MailboxFilterUrlMapping = (props: MailboxUrlParamsType, location: Location): FilterableMailBoxUrlSlugs => {
    let newParams: FilterableMailBoxUrlSlugs = {};

    newParams = {
        ...newParams,
        ...BuildMailboxUrlFilterFromParams(props, location,'term'),
        ...BuildMailboxUrlFilterFromParams(props, location,'startDate'),
        ...BuildMailboxUrlFilterFromParams(props, location,'endDate'),
        ...BuildMailboxUrlFilterFromParams(props, location,'mailType', MailType),
        ...BuildMailboxUrlFilterFromParams(props, location,'scanned', MailScanned),
        ...BuildMailboxUrlFilterFromParams(props, location,'unreadStatus', UnreadType),
        ...BuildMailboxUrlFilterFromParams(props, location,'mailTagIds', null, true),
        ...BuildMailboxUrlFilterFromParams(props, location,'incomingRecipientNameIds', null, true),
    }

    return newParams;
}

const BuildMailboxUrlFilterFromParams = (props: MailboxUrlParamsType, location: Location, name: keyof MailBoxUrlSlugs, data?: any, isArray?: boolean, overrideValue?: any): BuildMailboxUrlFilterFromParamsType => {
    return BuildUrlFilterFromParams(props, location, name, data, isArray, overrideValue);
}

export {
    MapFolderSlugToId,
    MailboxUrlMapping,
    MailboxFilterUrlMapping,
    BuildMailboxUrlFilterFromParams
}
